import React from 'react';
import './MobileAppBanner.css';

const MobileAppBanner = () => {
  return (
    <div className="mobile-app-banner">
      <div className="mobile-app-banner-content">
        <div className="mobile-app-banner-text">
          <h2>Now Available on Mobile!</h2>
          <p>Download our app for iOS and Android to search and track cards on the go.</p>
          <div className="mobile-app-banner-links">
            <a 
              href="https://apps.apple.com/us/app/hobby-exchange/id6743323051" 
              target="_blank" 
              rel="noopener noreferrer"
              className="mobile-app-banner-link"
            >
              Download for iOS
            </a>
            <a 
              href="https://play.google.com/store/apps/details?id=com.hobbyexchange.hexmobile&pli=1" 
              target="_blank" 
              rel="noopener noreferrer"
              className="mobile-app-banner-link"
            >
              Download for Android
            </a>
          </div>
        </div>
        <div className="mobile-app-banner-qr-section">
          <div className="mobile-app-banner-qr">
            <img 
              src="/qr-ios.png" 
              alt="iOS QR Code" 
            />
            <p>iOS</p>
          </div>
          <div className="mobile-app-banner-qr">
            <img 
              src="/qr-android.png" 
              alt="Android QR Code" 
            />
            <p>Android</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileAppBanner; 